import type { ModuleName } from '@contexts/modules-provider';

export const MODULE_ORDER: ModuleName[] = ['Manage', 'Train', 'Instruct'];

export interface ModuleContent {
  title: string;
  description: string;
  note?: string;
}

export const MODULE_CONTENT: Record<ModuleName, ModuleContent> = {
  Manage: {
    title: 'Manage',
    description:
      "View and manage your crew's training reservations and access training records.",
  },
  Train: {
    title: 'Train',
    description:
      'Find all your training details and course content in one place.',
    note: 'Previously CAE Crew Training',
  },
  Instruct: {
    title: 'Instruct',
    description:
      'View your instructing schedule, manage trainees and stay up to date with all things training.',
  },
};
